export const convertSerachParamsToURLSearchParams = (searchParams: {
  [key: string]: any | undefined
}): URLSearchParams => {
  const params = new URLSearchParams()

  Object.entries(searchParams).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v))
    } else if (value !== undefined) {
      params.set(key, value.toString())
    }
  })

  return params
}
